var map = {
	"./1sirous-namazi_pending_installation-view_magasin-iii_2023_photo-jean-baptiste-beranger_07-2048x1536.jpg": 7734,
	"./sirous-namazi_in-betweens_2023_photo_jean-baptiste-beranger_03-1536x2048.jpg": 1057,
	"./sirous-namazi_pending_installation-view_magasin-iii_2023_photo-jean-baptiste-beranger_03-2048x1536.jpg": 431,
	"./sirous-namazi_pending_installation-view_magasin-iii_2023_photo-jean-baptiste-beranger_14-1536x2048.jpg": 8973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4182;